package com.dwarshb.firebase


data class FirebaseUser(val emailID: String, val idToken: String,val uid: String)